import { Table, Typography } from 'antd';
import { useMemo } from 'react';
import { implementationMethodsConfig } from '../Block41';
import { implementationRequirementsConfig } from '../Block42';
import { FormBlock4DataTypes } from './DocumentPreviewSubjectData';
import { PreviewNestedData } from './PreviewNestedData';

export const DocumentPreviewBlock4 = ({
  data,
}: { data: FormBlock4DataTypes }) => {
  const tableData = useMemo(() => {
    const changedTableData = {
      implementationMethods: {
        key: 'implementationMethods',
        implementationMethods: {},
      },
      implementationRequirements: {
        key: 'implementationRequirements',
        implementationRequirements: {},
      },
    };

    if (data.implementationMethods) {
      changedTableData.implementationMethods.implementationMethods = (
        <PreviewNestedData
          fieldsData={data.implementationMethods}
          fieldsConfig={implementationMethodsConfig}
        />
      );
    }
    if (data.implementationRequirements) {
      changedTableData.implementationRequirements.implementationRequirements = (
        <PreviewNestedData
          fieldsData={data.implementationRequirements}
          fieldsConfig={implementationRequirementsConfig}
        />
      );
    }

    return changedTableData;
  }, [data]);

  return (
    <div>
      <Typography.Title level={5}>Patikrinamieji darbai</Typography.Title>
      <Table
        pagination={false}
        columns={[
          {
            key: 'implementationMethods',
            title: 'Atlikimo būdai',
            dataIndex: 'implementationMethods',
          },
        ]}
        dataSource={[
          tableData.implementationMethods
            ? tableData.implementationMethods
            : {},
        ]}
        size="small"
      />
      <Table
        pagination={false}
        columns={[
          {
            key: 'implementationRequirements',
            title: 'Atlikimo sąlygos',
            dataIndex: 'implementationRequirements',
          },
        ]}
        dataSource={[
          tableData.implementationRequirements
            ? tableData.implementationRequirements
            : {},
        ]}
        size="small"
      />
    </div>
  );
};
